import {normalize} from 'normalizr'
import barcodes_schema from '../schema/barcodes_schema'
import barcode_sets_schema from "../schema/barcode_sets_schema"
import api from '../../api'
import format from 'string-format'
import Vue from 'vue'

const SET_BARCODESET_LIST = 'SET_BARCODESET_LIST'
const SET_BARCODESET_BARCODES = 'SET_BARCODESET_BARCODES'
const SET_BARCODESET_NAMES = 'SET_BARCODESET_NAMES'
const SET_BARCODE_REMAINS = 'SET_BARCODE_REMAINS'
const SET_BARCODE_REMAIN = 'SET_BARCODE_REMAIN'
const SET_BARCODE_BOXES = 'SET_BARCODE_BOXES'


const initialState = {
  // наборы с баркодами (с баркодами)
  barcodeSets: {},
  // множетсво наборов, которые есть в barcodeSet_dict
  barcodeSet_names: new Set(),
  // словарь с описаниями баркдоных наборов (самих баркодов нет)
  barcodeSet_dict: [],
  // список доступных остатков
  available_barcode_remains: [],
  // список остатков баркодов
  barcode_remains: [],
  // список шкачиков с баркодами
  barcode_boxes: []
}

const actions = {

  /**
   * Получить список наборов баркодов (какие бывают).
   */
  listBarcodeSet: function ({commit, state}) {
    console.log("store.barcodes.listBarcodeSet() ")

    return api.barcodes.listBarcodeSet()
      .then(function (response) {
        // полученные из REST данные разложить в state через мутации
        // Данные из REST приходят в виде словаря с ключем по полю name (как в БД).
        const data = response.data

        commit(SET_BARCODESET_LIST, data)
      })
  },

  /**
   * Получить баркоды набора баркодов
   * @param commit
   * @param barcodeSet_name_set
   * @returns {*|PromiseLike<T>|Promise<T>}
   */
  getBarcodeSet: function ({commit, getters, dispatch}, {barcodeSet_name_set}) {
    console.log("store.barcodes.getBarcodeSet() ")

    return api.barcodes.getBarcodeSets(barcodeSet_name_set)
      .then(function (responses) {

        const responses_data = responses.map(x => x.data)
        const barcode_sets_norm = normalize(responses_data, barcode_sets_schema)
        const barcode_sets = barcode_sets_norm.entities.barcode_set_dict

        for (var barcodeSet_name in barcode_sets) {
          // объект списка баркодов набора баркодов для сохранения в store
          commit(SET_BARCODESET_BARCODES, [barcodeSet_name, barcode_sets[barcodeSet_name]])
        }
        return Promise.resolve()
          .then(function() {
            commit(SET_BARCODESET_NAMES, [barcode_sets_norm.result])
          })
          .catch(function (reason) {
            if (reason.response && reason.response.status && reason.response.status !== 403) { // Если это не просто проблема с аутентификацией
              dispatch('error/error_occurred', {error: reason, ok: false}, {root: true})
            }
          })
      })
  },

  /**
   * Запрашивает REST данные наборов баркодов
   * и обновляет состояние store.
   * @param commit
   * @param barcodeSet_name_set
   * @returns {*|PromiseLike<T>|Promise<T>}
   */
  get_missing_barcode_sets({state, dispatch}, {barcodeSet_name_set}) {
    state.barcodeSet_names.forEach(barcode_set_name => barcodeSet_name_set.delete(barcode_set_name))
    if(barcodeSet_name_set.size) {
      return dispatch('getBarcodeSet', {barcodeSet_name_set: barcodeSet_name_set})
    }
    else {
      return Promise.resolve()
    }
  },

  /**
   * Получить список доступных пользователю баркодных коробочек
   * @param commit
   * @param dispatch
   * @returns {Promise<postcss.Result> | Q.Promise<any> | *}
   */
  getBarcodeBoxes({commit, dispatch}) {
    return api.barcodes.getBarcodeBoxes()
      .then(function (response) {
        commit(SET_BARCODE_BOXES, response.data)
      })
      .catch(function (reason) {
        if (reason.response && reason.response.status && reason.response.status !== 403) { // Если это не просто проблема с аутентификацией
          dispatch('error/error_occurred', {error: reason, ok: false}, {root: true})
        }
      })
  },

  /**
   * Запросить остатки баркодов
   * @param commit
   * @param dispatch
   * @param query_list
   * @returns {Promise<T>}
   */
  getBarcodeRemains({commit, dispatch}, query_list) {
    return api.barcodes.getBarcodeRemains(query_list)
      .then(function(response) {
        commit(SET_BARCODE_REMAINS, response.data)
      })
      .catch(function (reason) {
        if (reason.response && reason.response.status && reason.response.status !== 403) { // Если это не просто проблема с аутентификацией
          dispatch('error/error_occurred', {error: reason, ok: false}, {root: true})
        }
      })
  },

  createBarcodeRemains({commit, dispatch}, barcode_remain_obj) {
    return api.barcodes.createBarcodeRemains(barcode_remain_obj)
      .then(function(response) {
        commit(SET_BARCODE_REMAIN, response.data)
      })
      .catch(function (reason) {
        if (reason.response && reason.response.status && reason.response.status !== 403) { // Если это не просто проблема с аутентификацией
          dispatch('error/error_occurred', {error: reason, ok: false}, {root: true})
        }
      })
  },
}

const mutations = {


  /**
   * Задать список баркодов набора баркодов
   * @param state
   * @param barcodeSet_name
   * @param barcodeSet_value
   */
  [SET_BARCODESET_BARCODES](state, [barcodeSet_name, barcodes]) {
    console.log(format("store.barcodes.mutations.SET_BARCODESET_BARCODES('{0}')", barcodeSet_name))
    const barcodeSet_barcodes_dict = normalize(barcodes.barcode2setmodel_set, barcodes_schema).entities.barcode2set

    state.barcodeSets[barcodeSet_name] = {}

    state.barcodeSets[barcodeSet_name]['barcodes_list'] = barcodes.barcode2setmodel_set
    state.barcodeSets[barcodeSet_name]['barcodes_dict'] = barcodeSet_barcodes_dict
  },
  [SET_BARCODESET_NAMES](state, [barcodeSet_names]) {
    barcodeSet_names.forEach(elem => state.barcodeSet_names.add(elem))
  },

  [SET_BARCODESET_LIST](state, list) {
    const dict = normalize(list, barcode_sets_schema)
    state.barcodeSet_dict = dict.entities.barcode_set_dict
  },

  [SET_BARCODE_REMAINS](state, list) {
    state.barcode_remains = list
  },

  [SET_BARCODE_REMAIN](state, barcode_remain) {
    for(let br in state.barcode_remains) {
      if(state.barcode_remains[br].barcode === barcode_remain.barcode && state.barcode_remains[br].box.id === barcode_remain.box.id) {
        Vue.set(state.barcode_remains, br, barcode_remain)
      }
    }
  },

  [SET_BARCODE_BOXES](state, list) {
    state.barcode_boxes = list
  }
}

export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations
}